export const SHOW_WARNING_MODAL = 'ui/SHOW_WARNING_MODAL'
